import { ApiFragment, IsAccessibleInViewer, RecordTypeStructure } from '@stylehaven/components';
import { ActionDisabledCondition, UserAction } from '../../entities/common/user-action.entity';

/*  Watch
 *  Available when:
 *   * item is NOT deleted
 *   * Item is NOT a representation
 *
 *  Disabled when:
 *   * Never
 */
export function GetWatchUserAction(record: ApiFragment): UserAction {
    const isDeleted: boolean = record.isDeleted();
    const isRepresentation: boolean = record.getRecordStructure() === RecordTypeStructure.Representation;

    const availableConditions: boolean[] = [!isDeleted, !isRepresentation];
    const disableConditions: ActionDisabledCondition[] = [];

    const watchAction: UserAction = new UserAction(availableConditions, disableConditions);

    return watchAction;
}

/*  Open in Viewer
 *  Available when:
 *   * item is NOT deleted
 *   * item is an access representation
 *
 *  Disabled when:
 *   * Never
 */
export function GetOpenInViewerUserAction(record: ApiFragment): UserAction {
    const isDeleted: boolean = record.isDeleted();
    const isAccessibleInViewer: boolean = IsAccessibleInViewer(record);

    const availableConditions: boolean[] = [!isDeleted, isAccessibleInViewer];
    const disableConditions: ActionDisabledCondition[] = [];

    return new UserAction(availableConditions, disableConditions);
}
